import styles from './LandingPage.module.scss'
import { CSSProperties } from 'react'
import Frame1Copy from './components/Frame1Copy'
import AllOrgsDotBar from './components/AllOrgsDotBar'
import StateByState from './components/StateByState'
import Initiatives from './components/Initiatives'
import FocusAreas from './components/FocusAreas'
import LiableInstitutions from './components/LiableInstitutions'
import InitiativesFunds from './components/InitiativesFunds'
import LineBreak from './components/LineBreak'
import ExploreTheMapButton from './components/ExploreTheMapButton'
import ScrollDownNotice from './components/ScrollDownNotice'
import Footer from './components/Footer'
import { Color } from '../../constants'

const CSS_VARS = {
  '--c-white': Color.White,
  '--c-black': Color.Black,
  '--c-light-black': Color.LightBlack,
}

function LandingPage() {
  return (
    <div style={CSS_VARS as CSSProperties} className={styles.root}>
      <LineBreak />

      <section className={styles.frameDefault}>
        <Frame1Copy />
        <AllOrgsDotBar />
      </section>

      <div className={styles.loneItemWrapper}>
        <ScrollDownNotice />
      </div>

      <section className={styles.frameInsetLightBlack}>
        <StateByState />
      </section>

      <div
        className={`${styles.frameTransitionWithBG} bg-focus-area-example`}
      ></div>

      <section className={styles.frameInsetLightBlack}>
        <Initiatives />
      </section>

      <LineBreak backgroundColor="var(--c-light-black)" />

      <section className={styles.frameInsetLightBlack}>
        <InitiativesFunds />
      </section>

      <section className={styles.frameDefault}>
        <FocusAreas />
      </section>

      <LineBreak />

      <section className={styles.frameDefault}>
        <LiableInstitutions />
      </section>

      <div className={styles.loneItemWrapper}>
        <ExploreTheMapButton />
      </div>

      <Footer />
    </div>
  )
}

export default LandingPage
